module.exports = __webpack_public_path__ + "static/media/remoteSchool.e0e0cbfe.svg";